<script setup>
import { ref, watch, nextTick } from 'vue';
import { useAuthStore } from '@/stores/auth';
import ChangePasswordModal from './ChangePasswordModal.vue';

const auth = useAuthStore();
const changePasswordModalRef = ref(null);

watch(
    () => auth.mustChangePasswordModal,
    async (obligatorio) => {
        if (!obligatorio) return;

        await nextTick();

        changePasswordModalRef.value?.openModal();
    },
    {
        immediate: true,
        flush: 'post'
    }
);
</script>

<template>
    <ChangePasswordModal ref="changePasswordModalRef" />
</template>